import { motion } from "framer-motion";
import { Calendar, Users, Target } from "lucide-react";

const ProgramDuration = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Section Title */}
        <motion.h2
          className="text-3xl md:text-4xl font-heading font-extrabold text-primary mb-12 tracking-tight"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Duration & Delivery
        </motion.h2>

        {/* Duration, Format, Outcome Tabs */}
        <div className="flex flex-col sm:flex-row justify-center gap-12 mb-12">
          <motion.div
            className="glass-card flex-1 p-8 bg-white shadow-xl rounded-xl"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex justify-center mb-4">
              <Calendar className="w-12 h-12 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-primary mb-2">Duration</h3>
            <p className="text-gray-700">3 to 12 months</p>
          </motion.div>

          <motion.div
            className="glass-card flex-1 p-8 bg-white shadow-xl rounded-xl"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex justify-center mb-4">
              <Users className="w-12 h-12 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-primary mb-2">Format</h3>
            <p className="text-gray-700">Online / Hybrid Mentorship</p>
          </motion.div>

          <motion.div
            className="glass-card flex-1 p-8 bg-white shadow-xl rounded-xl"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex justify-center mb-4">
              <Target className="w-12 h-12 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-primary mb-2">Outcome</h3>
            <p className="text-gray-700">Long-term organizational maturity</p>
          </motion.div>
        </div>

        {/* Stats Section */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="glass-card flex items-center justify-center p-6 bg-white shadow-lg rounded-xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span
              className="text-5xl font-bold text-primary"
              style={{ counterIncrement: "expertSessions" }}
            >
              <span className="counter" style={{ counterReset: "expertSessions" }}>6</span>
            </span>
            <p className="ml-2 text-lg text-gray-700">Expert Sessions</p>
          </motion.div>

          <motion.div
            className="glass-card flex items-center justify-center p-6 bg-white shadow-lg rounded-xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span
              className="text-5xl font-bold text-primary"
              style={{ counterIncrement: "ngosSupported" }}
            >
              <span className="counter" style={{ counterReset: "ngosSupported" }}>100</span>
            </span>
            <p className="ml-2 text-lg text-gray-700">NGOs Supported</p>
          </motion.div>

          <motion.div
            className="glass-card flex items-center justify-center p-6 bg-white shadow-lg rounded-xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span
              className="text-5xl font-bold text-primary"
              style={{ counterIncrement: "customizedRoadmap" }}
            >
              <span className="counter" style={{ counterReset: "customizedRoadmap" }}>1</span>
            </span>
            <p className="ml-2 text-lg text-gray-700">Customized Roadmap</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProgramDuration;
